import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function GCSCredentials() {
    return (
        <React.Fragment>
            <p>
                {' '}
                To configure Google Cloud Storage, you must create a <strong>Service Account</strong> in the Google
                Cloud Console. Generate a JSON encoded key to use as a credentials file.
            </p>

            <p>The service account must include account permissions for:</p>
            <ul>
                <li>
                    <strong>Storage Object Admin</strong>
                </li>
                <li>
                    <strong>Storage Object Creator</strong>
                </li>
                <li>
                    <strong>Storage Object Viewer</strong>
                </li>
            </ul>
        </React.Fragment>
    );
}

GCSCredentials.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GCSCredentials);
